<template>
  <el-dialog
    class="student-form-dialog"
    :title="isAdd ? $t('myChild.addProfile') : $t('myChild.editProfile')"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <el-form v-if="isAdd" :model="childForm" ref="childForm" label-width="0" class="demo-childForm">
      <div class="addFormList">
        <p>{{ $t('myChild.pickAvatar') }}</p>
        <img v-if="!selectedData.url" @click="chooseImg" src="../../assets/Ellipse 1088.svg" alt="">
        <div v-else class="avatar-row">
          <img :src="selectedData.url" alt="">
          <i class="el-icon-edit editBtn" @click="chooseImg"></i>
        </div>
        <p>{{ $t('myChild.childName') }}</p>
        <el-form-item prop="name">
          <el-input
            :class="changeFlag == 1 ? '' : 'errorPass'"
            type="text"
            v-model="childForm.name"
            autocomplete="off"
            :placeholder="$t('myChild.name')"
          ></el-input>
        </el-form-item>
        <p>{{ $t('myChild.childBirth') }}</p>
        <el-date-picker
          v-model="childForm.birth_date"
          type="date"
          align="left"
          format="MM/dd/yyyy"
          placeholder="MM/DD/YYYY"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <el-button type="primary" class="submit-btn" @click="toAdd">{{ $t('myChild.add') }}</el-button>
    </el-form>

    <el-form v-else :model="editForm" ref="editFormRef" label-width="0" class="demo-childForm">
      <div class="addFormList">
        <p>{{ $t('myChild.pickAvatar') }}</p>
        <div class="avatar-row">
          <img :src="editForm.avatar" alt="">
          <i class="el-icon-edit editBtn" @click="chooseImg"></i>
        </div>
        <p>{{ $t('myChild.childName') }}</p>
        <el-form-item prop="name">
          <el-input
            :class="changeFlag == 1 ? '' : 'errorPass'"
            type="text"
            v-model="editForm.nickname"
            autocomplete="off"
            :placeholder="$t('myChild.name')"
          ></el-input>
        </el-form-item>
        <p>{{ $t('myChild.childBirth') }}</p>
        <el-date-picker
          v-model="editForm.birth_date"
          type="date"
          align="left"
          format="MM/dd/yyyy"
          placeholder="MM/DD/YYYY"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <el-button type="primary" class="submit-btn" @click="toEdit">{{ $t('myChild.saveChange') }}</el-button>
    </el-form>

    <div v-if="showMessageBox" class="avatar-picker-overlay">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>{{ $t('myChild.pickAvatar') }}:</span>
          </div>
          <button type="button" class="el-message-box__headerbtn" @click="chooseImg">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <div class="el-message-box-avatar">
                <p v-for="(item, i) in getAvatar" :key="i">
                  <img @click="chooseAvatar(item)" :src="item.url" alt="">
                  <img class="borderAvatar" v-if="item.selected" src="../../assets/Ellipse108.svg" alt="">
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--primary" @click="submitAvatar">
            <span>{{ $t('myChild.select') }}</span>
          </button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'StudentFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'add'
    },
    student: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      childForm: {
        name: '',
        birth_date: ''
      },
      editForm: {
        avatar: '',
        nickname: '',
        birth_date: '',
        student_sn: ''
      },
      changeFlag: 1,
      showMessageBox: false,
      getAvatar: [],
      selectedData: {},
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() >= Date.now()
        }
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    isAdd () {
      return this.mode === 'add'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.initForm()
        this.loadAvatars()
      }
    }
  },
  methods: {
    initForm () {
      if (this.isAdd) {
        this.childForm = { name: '', birth_date: '' }
        this.selectedData = {}
      } else if (this.student) {
        this.editForm = { ...this.student }
      }
    },
    resetForm () {
      this.showMessageBox = false
      this.childForm = { name: '', birth_date: '' }
      this.editForm = { avatar: '', nickname: '', birth_date: '', student_sn: '' }
      this.selectedData = {}
    },
    loadAvatars () {
      this.$http.get('/api/obtainStuImg').then((res) => {
        if (res.data.code == 200) {
          this.getAvatar = res.data.data.data
          this.getAvatar.forEach((item) => {
            const avatarUrl = this.isAdd ? this.selectedData.url : this.editForm.avatar
            item.selected = item.url === avatarUrl
            if (item.selected) {
              this.selectedData = item
            }
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    chooseImg () {
      this.showMessageBox = !this.showMessageBox
    },
    chooseAvatar (avatarItem) {
      this.getAvatar.forEach((item) => {
        item.selected = item.id === avatarItem.id
      })
      this.$forceUpdate()
    },
    submitAvatar () {
      this.showMessageBox = false
      this.getAvatar.forEach((item) => {
        if (item.selected) {
          this.editForm.avatar = item.url
          this.selectedData = item
        }
      })
    },
    toAdd () {
      if (!this.selectedData.url) {
        this.$message({
          message: this.$t('errorprompt.selectAvatar'),
          type: 'warning'
        })
        return false
      }
      if (!this.childForm.birth_date) {
        this.$message({
          message: this.$t('errorprompt.selectBirthday'),
          type: 'warning'
        })
        return false
      }
      if (!this.childForm.name) {
        this.$message({
          message: this.$t('errorprompt.selectName'),
          type: 'warning'
        })
        return false
      }
      this.$http.post('/api/learner', {
        avatar: this.selectedData.url,
        birth_date: this.utils.setDate(this.childForm.birth_date),
        nickname: this.childForm.name
      }).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    toEdit () {
      if (!this.editForm.avatar) {
        this.$message({
          message: this.$t('errorprompt.selectAvatar'),
          type: 'warning'
        })
        return false
      }
      if (!this.editForm.birth_date) {
        this.$message({
          message: this.$t('errorprompt.selectBirthday'),
          type: 'warning'
        })
        return false
      }
      if (!this.editForm.nickname) {
        this.$message({
          message: this.$t('errorprompt.selectName'),
          type: 'warning'
        })
        return false
      }
      this.$http.post('/api/learner/save', {
        avatar: this.editForm.avatar,
        nickname: this.editForm.nickname,
        birth_date: this.utils.setDate(this.editForm.birth_date),
        student_sn: this.editForm.student_sn
      }).then((res) => {
        if (res.data.code == 200) {
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.student-form-dialog {
  /deep/ .el-dialog__body {
    padding: 10px 24px 24px;
  }

  p {
    font-size: 16px;
    color: #424347;
    margin: 12px 0 8px;
  }

  .addFormList {
    img {
      width: 86px;
      height: 86px;
      cursor: pointer;
      margin: 8px 0 16px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .avatar-row {
    display: flex;
    align-items: center;
    margin: 8px 0 16px;

    img {
      margin: 0;
    }

    .editBtn {
      font-size: 36px;
      color: #B50604;
      cursor: pointer;
      margin-left: 16px;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 10px;

    .el-form-item__content {
      margin-left: 0 !important;

      .el-input {
        border-bottom: 1px solid #a5a5a5;
      }

      .errorPass {
        border-bottom: 1px solid #fc424c;
      }

      .el-input__inner {
        border: none;
        background: none;
        font-size: 16px;
        color: #353643;
        padding: 0;
        height: 40px;
        border-radius: 0;
      }
    }
  }

  /deep/ .el-date-editor {
    width: 100%;
    border: none;
    border-bottom: 1px solid #a5a5a5;
    border-radius: 0;

    input {
      border: none;
      padding: 0;
      text-align: left;
    }

    .el-icon-date,
    .el-input__icon,
    .el-range__close-icon {
      display: none;
    }
  }

  .submit-btn {
    width: 100%;
    height: 44px;
    margin-top: 24px;
    background: #B50604;
    border-color: #B50604;
    border-radius: 8px;
    font-size: 16px;
  }
}

.avatar-picker-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;

  .el-message-box {
    background: #ffffff;
    width: 640px;
    max-width: calc(100vw - 32px);
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .el-message-box__header {
    flex-shrink: 0;
  }

  .el-message-box__content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 8px 24px 0;
  }

  .el-message-box__btns {
    flex-shrink: 0;
    text-align: center;
    padding: 16px 0;

    button {
      width: 200px;
      height: 44px;
      background: #B50604;
      border-color: #B50604;
      border-radius: 8px;
      color: #fff;
    }
  }

  /deep/ .el-message-box-avatar {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px 12px;
    padding: 8px 0 16px;

    p {
      position: relative;
      display: block;
      width: 80px;
      height: 80px;
      margin: 0;
      flex-shrink: 0;
    }

    p img {
      width: 80px;
      height: 80px;
      margin: 0;
      border-radius: 50%;
      object-fit: cover;
      cursor: pointer;
    }

    p .borderAvatar {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/children/StudentFormDialog.vue